import { ENTITY_TYPE, FEATURES } from '../constants/featureFlags'

angular.module('surfsightApp.controllers').controller('profileDropdownCtrl', [
  '$scope',
  '$rootScope',
  '$log',
  '$state',
  '$timeout',
  '$interval',
  '$location',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdMedia',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  'edgeFactory',
  'leafletData',
  'configurationService',
  'userFactory',
  function (
    $scope,
    $rootScope,
    $log,
    $state,
    $timeout,
    $interval,
    $location,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdMedia,
    $mdSidenav,
    $mdToast,
    $mdColors,
    edgeFactory,
    leafletData,
    configurationService,
    userFactory
  ) {
    var $translate = $filter('translate')
    $scope.$on('organizationChanged', function (e, organization) {
      $rootScope.currentUserOrganization = organization
    })
    $scope.userDetails = $localStorage.userDetails
    $scope.appConfig = configurationService.getState()

    $scope.themePrimary = $mdColors.getThemeColor('primary')
    $scope.themeAccent = $mdColors.getThemeColor('accent')

    $scope.goToNewVersion = goToNewVersion

    $scope.toggleSideNav = function (sidenav_id = 'left-sidenav') {
      // alert(sidenav_id);
      $mdSidenav(sidenav_id).toggle()
    }
    $scope.mdMedia = function (q) {
      return $mdMedia(q)
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .actionKey('F1')
        .action('ok')
        .position('top right')
        .hideDelay(10000)

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }
    $scope.userDetails = $localStorage.userDetails
    $scope.getUserOrganization = function () {
      var request_json = {
        method: 'GET',
        url:
          USER_BASEURL +
          '/organization/' +
          $localStorage.userDetails.organizationId,
        data: $scope.edgeData
      }
      $http(request_json).then(function (response) {
        if (response.data.status.code == 0) {
          $localStorage.userDetails.organization = response.data.organization
          $localStorage.userOrganization = response.data.organization

          $scope.userOrganization = $localStorage.userOrganization
          $scope.currentUserOrganization = $scope.userOrganization
          $localStorage.currentUserOrganization.name =
            $scope.userOrganization.name
        }
      })
    }

    $scope.getUserOrganizations = function () {
      if ($localStorage.isResellerSso) return
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/user/' + $localStorage.userDetails.id
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            $scope.userOrganizationsList = response.data.user
            // ~ console.log($scope.userOrganizationsList);
          } else {
            alert(response.data.status.error)
          }
        },
        function () {
          alert('Error Occurred')
        }
      )
    }
    if (!$localStorage.userOrganization) {
      // retrieving default organization
      $scope.getUserOrganization()
      // $scope.currentUserOrganization=$localStorage.userOrganization;
    } else {
      $scope.userOrganization = $localStorage.userOrganization
      $scope.currentUserOrganization = $localStorage.currentUserOrganization
    }
    // retrieving assigned organizations list
    $scope.getUserOrganizations()
    $scope.logout = function () {
      $state.go('logout')
    }
    $scope.showChangePassword = function (ev) {
      $mdDialog
        .show({
          controller: 'ChangePasswordController',
          templateUrl:
            './templates/changePassword.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {
            $scope.showMessageToast(response.data.status.error)
          },
          function (response) {
            $scope.status = 'You cancelled the dialog.'
          }
        )
        .catch()
    }

    $scope.changeOrganization = function (ev) {
      $mdDialog
        .show({
          locals: {
            userOrganizationsList: $scope.userOrganizationsList
          },
          controller: 'organizationChangeController',
          templateUrl:
            './templates/organization.change.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (organization) {
            $http({
              method: 'GET',
              url: USER_BASEURL + '/organization/' + organization.id
            }).then(function (response) {
              if (response.data.status.code == 0) {
                $localStorage.userOrganization = response.data.organization

                $scope.$emit('organizationChanged', organization)
                $localStorage.currentUserOrganization = organization
                $state.go('home.common.edge.list')
              }
            })
          },
          function (response) {}
        )
        .catch()
    }
    if ($scope.userDetails.is_reseller) {
      $scope.partnerData = $localStorage.partnerData
    }
    $scope.showPartnerBlock = function () {
      $state.go('home.common.settings.partners')
    }
    $scope.showManageOrganization = function () {
      $scope.$emit('controlManageOrganization', { action: 'open' })
    }
    $scope.showManageOrganizationUsers = function () {
      $state.go('home.common.settings.users')
    }
    if (!$localStorage.currentUserOrganization.name) {
      $scope.currentUserOrganization = $localStorage.userOrganization
    }
    $scope.showUserSettings = function (ev) {
      $mdDialog
        .show({
          controller: 'userSettingsController',
          templateUrl:
            './templates/userSettings.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {
            $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
          },
          function (response) {
            $scope.status = 'You cancelled the dialog.'
          }
        )
        .catch()
    }
    $scope.showOrgSettings = function (ev) {
      const getRetentionSettingsPromise = $http({
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${$localStorage.currentUserOrganization.id}`
      })
      const getDefaultSettingsPromise = $http({
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${$localStorage.currentUserOrganization.id}/default-settings`
      })
      $scope.checkDynamicAdjustFeatureFlag = async () => {
        try {
          const response = await $http({
            method: 'GET',
            url: `${DEVICEMANAGER_BASEURL}/v1/feature-flag/entity-access`,
            params: {
              featureName: FEATURES.DYNAMIC_ADJUST,
              entityId: $localStorage.userOrganization.id,
              entityType: ENTITY_TYPE.ORGANIZATION
            }
          })
          $rootScope.dynamicAdjustFeatureEnabled =
            response.data && response.data.data && response.data.data.access
        } catch (error) {
          $rootScope.dynamicAdjustFeatureEnabled = false
          console.error('Error fetching feature flag:', error)
        }
      }
      $scope.checkDynamicAdjustFeatureFlag()

      $scope.checkIfOrgHasAI14 = async () => {
        try {
          const response = await $http({
            method: 'GET',
            url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/has-mqtt-device`
          })
          $localStorage.isOrgAllDevicesAI12 =
            (response.data && !response.data.data.hasMqttDevice) || false
        } catch (error) {
          console.error('Error fetching feature flag:', error)
        }
      }
      $scope.checkIfOrgHasAI14()
      Promise.all([getRetentionSettingsPromise, getDefaultSettingsPromise])
        .then(([orgSettings, defaultSetting]) => {
          const retentionConfig = orgSettings.data.data.deviceRetentionMinutes
          const _res = defaultSetting.data.data
          const organizationSettings = {
            organizationDeviceSetting: _res.device,
            organizationEventsSetting: _res.events,
            organizationEventWebhookURLs: JSON.parse(_res.eventWebhookUrl),
            organizationEventWebhookConfig: JSON.parse(_res.eventWebhookConfig),
            organizationGpsWebhookURLs: JSON.parse(_res.gpsWebhookUrl),
            organizationAlarmsWebhookURLs: JSON.parse(_res.alarmsWebhookUrl),
            organizationAlarmsWebhookConfig: JSON.parse(
              _res.alarmsWebhookConfig
            ),
            organizationSystemMessagesWebhook: JSON.parse(
              _res.systemMessagesWebhook
            ),
            organizationRetentionSettings: retentionConfig,
            isYawnEvFeatureEnabledForPartnerOfOrganization:
              _res.isYawnEvFeatureEnabledForPartnerOfOrganization,
            maxVersionForEventsPage: _res.maxVersionForEventsPage
          }
          $scope.organizationSettings = organizationSettings
          $rootScope.organizationSettings = organizationSettings
          $mdDialog
            .show({
              controller: 'organizationSettingsController',
              templateUrl:
                './templates/organizationSettings.view.html?t=' +
                window.webpackHash,
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            })
            .then(
              function (response) {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              },
              function (response) {
                $scope.status = 'You cancelled the dialog.'
              }
            )
            .catch()
        })
        .catch()
    }
    function goToNewVersion () {
      /* 0.0.0.0 is presented since it allows to share cookie between domain */
      var SHARED_LOCAL_DOMAIN = '0.0.0.0'
      var url = window.origin.includes(SHARED_LOCAL_DOMAIN)
        ? 'https://' + SHARED_LOCAL_DOMAIN + ':3000'
        : NEW_APP_URL
      userFactory.setAuth(
        $localStorage.userToken,
        $localStorage.userDetails.organizationId
      )
      window.open(url + '/maps', '_self')
    }
  }
])
